<template>
  <v-app-bar v-if="$store.state.auth.userProfileList" class="main-header" height="64" fixed color="primary" dark>
    <v-btn icon class="ml-1" @click.stop="$store.dispatch('toggleDrawer')">
      <template>
        <v-icon style="font-size: 28px">mdi-menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title :class="$vuetify.breakpoint.smAndUp ? '' : 'px-0'">
      <v-card
        to="/dashboard"
        color="transparent"
        flat
      >
        <div :class="$vuetify.breakpoint.smAndUp ? 'text-headline' : 'text-body-1'">
          {{ $store.state.appSettings.company.shortName }}
        </div>
      </v-card>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu
      min-width="180"
      max-width="350"
      offset-y
      bottom
      left
      nudge-bottom="10"
      z-index="9999"
    >
      <template v-slot:activator="{ on, attrs, value}">
        <v-card 
          class="d-flex align-center"
          color="transparent"
          flat
          v-bind="attrs"
          v-on="on"
        >
          <v-avatar
            color="info"
            size="45"
          >
            <span class="white--text">{{ $store.state.auth.user.userInitial }}</span>
          </v-avatar>
          <div :class="$vuetify.breakpoint.smAndUp  ? 'mx-4 text-caption' : 'mx-4'">
            <div v-if="$vuetify.breakpoint.smAndUp">Hi, {{ $store.state.auth.user.fullName }}</div>
            <div>{{ $store.state.auth.user.securityProfileName }}</div>
          </div>
          <div>
            <v-icon>
              {{ value ? 'mdi-menu-up' : 'mdi-menu-down' }}
            </v-icon>
          </div>
        </v-card>
      </template>
        <v-list>
          <v-list-item class="text-center">
            <v-list-item-content>
              <v-list-item-avatar height="54">
                <v-avatar color="info" size="54">
                  <span 
                    class="white--text headline"
                    >{{ $store.state.auth.user.userInitial }}</span>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-title>
                Hi, {{ $store.state.auth.user.fullName }}
              </v-list-item-title>
              <v-list-item-title class="primary--text font-weight-bold">
                {{ $store.state.auth.user.securityProfileName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $store.state.auth.user.originationChannelName }} - {{ $store.state.auth.user.organizationName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item-group 
            color="primary"
          >
            <v-hover
              v-for="(profile, i) in $store.state.auth.userProfileList.filter(x => x.userOrgProfileId !== $store.state.auth.user.userOrgProfileId)"
              :key="`profile-${i}`" 
              v-slot="{ hover }"
            >
              <v-list-item
                @click="handleSwitchUserProfile(profile)"
              >
                <v-list-item-action
                  class="mr-4"
                >
                  <v-icon
                    :color="hover ? 'warning' : 'grey lighten-2'"
                    class="mx-auto"
                  >
                    mdi-star
                  </v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{ profile.securityProfileName }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ profile.organizationName }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <small>{{ profile.originationChannelName }}</small>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-hover>
          </v-list-item-group>
          <v-divider></v-divider>
          <div class="d-flex justify-center my-3">
            <v-btn
              width="80%"
              large
              outlined
              color="error"
              class="text-capitalize"
              @click="$store.dispatch('auth/logout')">Sign Out
            </v-btn>
          </div>
        </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { convert } from "@/mixins";

export default {
  computed: {
    DRAWER_STATE: {
      get() {
        return this.$store.state.drawer;
      },
      set(newValue) {
        if (newValue === this.$store.state.drawer) return;
        else this.$store.dispatch('toggleDrawer');
      },
    },
  },
  methods: {
    async handleSwitchUserProfile(userProfile) {
      await this.$store.dispatch("auth/switchUserProfile", userProfile);
      await this.$store.dispatch("auth/getNavMenuList");
    },
  },
  mixins: [convert]
};
</script>

<style src="@/styles/HeaderBar.scss" lang="scss"></style>